module.exports = __webpack_public_path__ + "img/ico_menual07_off.beb3e131.svg";